module.exports = __webpack_public_path__ + "img/SketchPngd2b773c65d428a5a34a488840131ed0f7f93e2908d682ac69edd637d59a41b87.8556fb2c.png";